import {
  CHECKLIST_MAIN_PAGE_VIEWED_ANALYTICS,
  CHECKLIST_HOUSE_STEP_CLICKED_ANALYTICS,
  CHECKLIST_EXTERNAL_AREA_CLICKED_ANALYTICS,
  FINISH_CHECKLIST_CLICKED_ANALYTICS,
  CHECKLIST_GENERAL_CONDITIONS_CLICKED_ANALYTICS,
} from 'containers/Checklist/types';

import {
  CHECKLIST_EXTERNAL_AREA_PAGE_VIEWED_ANALYTICS,
  EXTERNAL_AREA_FINISH_BUTTON_CLICKED_ANALYTICS,
} from 'containers/Checklist/ExternalArea/types';
import {
  CHECKLIST_HOUSE_PAGE_VIEWED_ANALYTICS,
  HOUSE_FINISH_BUTTON_CLICKED_ANALYTICS,
} from 'containers/Checklist/House/types';

import { logWithDefaultProperties } from '../defaultLogger';
import { PAGE_NAMES } from '../constants';

export const handleChecklistActions = (amplitudeInstance, action) => {
  switch (action.type) {
    case CHECKLIST_MAIN_PAGE_VIEWED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_viewed',
        extraProperties: action.extraProperties,
      });
      break;

    case CHECKLIST_EXTERNAL_AREA_PAGE_VIEWED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_external_area_step_viewed',
        extraProperties: action.extraProperties,
      });
      break;

    case CHECKLIST_HOUSE_STEP_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_house_step_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case CHECKLIST_EXTERNAL_AREA_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_external_area_step_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case CHECKLIST_GENERAL_CONDITIONS_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_general_conditions_clicked_analytics',
        extraProperties: {
          photoSessionId: action.extraProperties.photoSessionId,
          houseId: action.extraProperties.houseId,
          house_area: action.extraProperties.houseArea,
          full_evaluation: action.extraProperties.fullEvaluation,
        },
      });
      break;

    case CHECKLIST_HOUSE_PAGE_VIEWED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_house_step_viewed',
        extraProperties: action.extraProperties,
      });
      break;

    case FINISH_CHECKLIST_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'photo_session_finish_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case HOUSE_FINISH_BUTTON_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_house_step_finish_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    case EXTERNAL_AREA_FINISH_BUTTON_CLICKED_ANALYTICS:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.CHECKLIST,
        eventName: 'checklist_external_area_step_finish_clicked',
        extraProperties: action.extraProperties,
      });
      break;

    default:
      break;
  }
};

export default handleChecklistActions;
